import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router'
import { Outlet } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { queries } from 'src/lib/query-keys'
import WorkManVideoFallback from 'src/shared/assets/vid/work-man.mov'
import WorkManVideoWebm from 'src/shared/assets/vid/work-man.webm'
import { useAuthState } from 'src/shared/features/auth/api/use-auth-state'
import AuthLayoutBase from 'src/shared/features/auth/components/auth-layout-base'
import AuthSideContentVid from 'src/shared/features/auth/components/auth-side-content-vid'

export default function AuthLayout() {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { isSignedIn, needsOnboarding } = useAuthState()
  const [searchParams] = useSearchParams()
  const redirectTo = searchParams.get('redirectTo')

  useEffect(() => {
    const cachedUser = queryClient.getQueryData(queries.users.me.queryKey)

    if (cachedUser) {
      // TODO: Make the business tab the default tab. Change back to home page once it is implemented.
      navigate(redirectTo ? redirectTo : paths.business.getHref(), {
        replace: true,
      })
    } else if (isSignedIn && needsOnboarding) {
      navigate(paths.auth.onboarding.getHref(redirectTo || ''), {
        replace: true,
      })
    } else if (isSignedIn && !needsOnboarding) {
      // TODO: Make the business tab the default tab. Change back to home page once it is implemented.
      navigate(redirectTo ? redirectTo : paths.business.getHref(), {
        replace: true,
      })
    }
  }, [isSignedIn, needsOnboarding, queries.users.me.queryKey, redirectTo, navigate])

  return (
    <AuthLayoutBase
      linksVariant="help-and-privacy"
      sideContent={<AuthSideContentVid src={WorkManVideoWebm} fallbackSrc={WorkManVideoFallback} />}
    >
      <Outlet />
    </AuthLayoutBase>
  )
}
